import React from "react";
import styles from "./opening-hours.module.scss";

function OpeningHours({ openingHours }) {
  const { days, times } = openingHours?.[0] || {};

  const formatTimeRange = times => {
    if (!times) return "";

    if (!times.includes("-") && !times.includes("–") && !times.includes("—")) {
      return times;
    }

    const [start, end] = times.split(/[-–—]/).map(t => t.trim());

    const formatTime = time => {
      if (!time) return "";

      const ampmMatch = time.match(/^(\d{1,2})(?::(\d{2}))?(am|pm)?$/i);

      if (!ampmMatch) return time;

      let [, hours, minutes, suffix] = ampmMatch;

      hours = Number(hours);
      minutes = minutes ? Number(minutes) : 0;

      if (!suffix) {
        if (hours >= 1 && hours <= 7) {
          suffix = "pm";
        } else {
          suffix = hours >= 12 ? "pm" : "am";
        }

        hours = hours % 12 || 12;
      }

      return minutes === 0 ? `${hours}${suffix}` : `${hours}:${String(minutes).padStart(2, "0")}${suffix}`;
    };

    return `${formatTime(start)} to ${formatTime(end)}`;
  };

  return (
    <div>
      {openingHours?.length > 1 ? (
        <ul className={styles["opening-hours__multiline-availability"]}>
          {openingHours.map(({ days, times }) => (
            <li key={days} className={styles["opening-hours__availability-li"]}>
              <span className={styles["opening-hours__days"]}>{`${days}, `}</span>
              <span className={styles["opening-hours__hours"]}>{formatTimeRange(times)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles["opening-hours__single-availability"]}>
          <span>
            Available {days}, {formatTimeRange(times)}
          </span>
        </p>
      )}
    </div>
  );
}

export default OpeningHours;
